import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalService } from 'src/app/services/global/global.service';
import { EncryptionDecryptionService } from 'src/app/services/encryption-decryption/encryption-decryption.service';
import { AppService } from 'src/app/services/app/app.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root'
})
export class HeaderInterceptor implements HttpInterceptor {
    private request:any;
    constructor(private edService:EncryptionDecryptionService,private appService:AppService,private cookieService:CookieService) { 
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.request=request;
        request = request.clone({
            setHeaders: {
                'Authorization':this.getToken(),
            }
        });
        return next.handle(request)
    }
  getToken(){
    //set different header if stripe api (set secret key as stripe header )
    if(this.request.url.includes('https://api.stripe.com')==false){
        let token_value
        // have used the method to get token value from local storage as other wise was causing the type issue in angular 12,
        if(window.location.href.includes('cdashboard')||window.location.href.includes('doc-dashboard')||window.location.href.includes('admin-cert')||
        window.location.href.includes('admin-cert')||window.location.href.includes('iframe') ){
            token_value=localStorage.getItem('training-portal.admin-authToken') != null ? localStorage.getItem('training-portal.admin-authToken') : '';
            // token_value=localStorage.getItem('training-portal.admin-authToken') != null ? localStorage.getItem('training-portal.admin-authToken') : '';
      
        }
        
        else{ 
            token_value=this.cookieService.get(this.appService.getEncryptedText('training-portal.authToken')) != null ? this.cookieService.get(this.appService.getEncryptedText('training-portal.authToken')) : '';
            // token_value=this.appService.getData('training-portal.authToken') != null ? this.appService.getData('training-portal.authToken') : '';
            //  token_value=localStorage.getItem('training-portal.authToken') != null ? localStorage.getItem('training-portal.authToken') : '';
            if(token_value==null){
            token_value=this.appService.getData('training-portal.authToken') != null ? this.appService.getData('training-portal.authToken') : ''; 
            }
        }
        return token_value;
    }
    else{
        return 'Bearer' + ' ' + GlobalService.stripeSecretKey
    }
}
}
